import React from 'react'
import { NavLink } from 'react-router'
import { Collapse, Divider } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import { sidebarNestedLinkIconSx } from '@/layout-blueprints/chromeComponentSx'

const SettingsSection = ({
  settingsDropdownOpen,
  toggleSettingsDropdown,
  toggleSidebarMobile,
  session,
}) => {
  const member = session?.me?.activeOrg?.member

  return (
    <li>
      <a
        id="leftNavSettings"
        data-tour="comps-step-4"
        href="#/"
        onClick={toggleSettingsDropdown}
        data-nav-active={settingsDropdownOpen || undefined}
      >
        <span data-hf="sidebar-icon">
          <SettingsTwoToneIcon />
        </span>
        <span data-hf="sidebar-item-label">Settings</span>
        <span data-hf="sidebar-icon-indicator">
          <ChevronRightTwoToneIcon />
        </span>
      </a>
      <Collapse in={settingsDropdownOpen}>
        <ul>
          <li>
            <NavLink
              id="leftNavSettingsPersonal"
              onClick={toggleSidebarMobile}
              to="/settings/personal"
              end
            >
              <FontAwesomeIcon
                sx={sidebarNestedLinkIconSx}
                icon={['far', 'user']}
                size="1x"
                fixedWidth
              />
              Personal
            </NavLink>
          </li>
          {session?.me?.activeOrg?.member !== 'RWN' && (
            <li>
              <NavLink
                id="leftNavSettingsOrganization"
                onClick={toggleSidebarMobile}
                to="/settings/organization"
                end
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['far', 'building']}
                  size="1x"
                  fixedWidth
                />
                Organization
              </NavLink>
            </li>
          )}
          {(member === 'pacemorby' || member === 'astroflip') && (
            <li>
              <NavLink
                id="leftNavDealSauceBuyBox"
                onClick={toggleSidebarMobile}
                to="/dealsauce-buybox"
                end
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['fas', 'box']}
                  size="1x"
                  fixedWidth
                />
                Dealsauce Buy Box
              </NavLink>
            </li>
          )}
          <li>
            <NavLink
              id="leftNavSettingsAssumptions"
              onClick={toggleSidebarMobile}
              to="/settings/assumptions"
              end
            >
              <FontAwesomeIcon
                sx={sidebarNestedLinkIconSx}
                icon={['fas', 'sliders']}
                size="1x"
                fixedWidth
              />
              Assumptions
            </NavLink>
          </li>
          {session?.me?.activeOrg?.member !== 'RWN' && (
            <li>
              <NavLink
                id="leftNavSettingsTeam"
                onClick={toggleSidebarMobile}
                to="/settings/team"
                end
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['fas', 'user-group']}
                  size="1x"
                  fixedWidth
                />
                Team
              </NavLink>
            </li>
          )}
          {session?.me?.activeOrg?.member !== 'RWN' && (
            <li>
              <NavLink
                id="leftNavSettingsMarketplace"
                onClick={toggleSidebarMobile}
                to="/settings/marketplace"
                end
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['fas', 'sign-hanging']}
                  size="1x"
                  fixedWidth
                />
                Marketplace
              </NavLink>
            </li>
          )}
          {/* Integrations menu item commented out
          {(session?.me?.activeOrg?.member === 'pacemorby' ||
            session?.me?.activeOrg?.member === 'astroflip' ||
            session?.me?.activeOrg?.member === 'pep') && (
            <li>
              <NavLink
                id="leftNavSettingsIntegrations"
                onClick={toggleSidebarMobile}
                to="/settings/integrations"
                end
              >
                <FontAwesomeIcon
                  sx={sidebarNestedLinkIconSx}
                  icon={['far', 'link']}
                  size="1x"
                  fixedWidth
                />
                Integrations
              </NavLink>
            </li>
          )}
          */}
          <li>
            <NavLink
              id="leftNavSettingsBilling"
              onClick={toggleSidebarMobile}
              to="/settings/billing"
              end
            >
              <FontAwesomeIcon
                sx={sidebarNestedLinkIconSx}
                icon={['far', 'file-lines']}
                size="1x"
                fixedWidth
              />
              Billing
            </NavLink>
          </li>
        </ul>
      </Collapse>
      <Divider />
    </li>
  )
}

export default SettingsSection
